import { Textarea } from '@cartwheel/components'
import { useId } from 'react'

export function InternalBillingNoteField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  const id = useId()

  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-base font-semibold leading-[1.5] text-charcoal">
        Internal billing note
      </label>
      <Textarea
        id={id}
        value={value}
        rows={3}
        onChange={(event) => onChange(event.target.value)}
        placeholder="e.g. Verified via Availity 6/9, agent Diana, ref #4471, copay $20"
      />
      <p className="text-xs leading-[1.5] text-charcoal-50">
        Pinned to the student page activity log for billing. Not shown to the family.
      </p>
    </div>
  )
}
